import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { BUFFER_TYPE } from '@pixi/constants';
import { Runner } from '@pixi/runner';
var UID = 0;
var Buffer = /*#__PURE__*/function () {
  function Buffer(data) {
    var _static = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _classCallCheck(this, Buffer);
    this.data = data || new Float32Array(1);
    this._glBuffers = {};
    this._updateID = 0;
    this.index = index;
    this.static = _static;
    this.id = UID++;
    this.disposeRunner = new Runner("disposeBuffer");
  }
  _createClass(Buffer, [{
    key: "update",
    value: function update(data) {
      if (data instanceof Array) {
        data = new Float32Array(data);
      }
      this.data = data || this.data;
      this._updateID++;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposeRunner.emit(this, false);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.dispose();
      this.data = null;
    }
  }, {
    key: "index",
    get: function get() {
      return this.type === BUFFER_TYPE.ELEMENT_ARRAY_BUFFER;
    },
    set: function set(value) {
      this.type = value ? BUFFER_TYPE.ELEMENT_ARRAY_BUFFER : BUFFER_TYPE.ARRAY_BUFFER;
    }
  }], [{
    key: "from",
    value: function from(data) {
      if (data instanceof Array) {
        data = new Float32Array(data);
      }
      return new Buffer(data);
    }
  }]);
  return Buffer;
}();
export { Buffer };